export const FEATURE_GROUPS = Object.freeze({
  DATA_EXPORT_STANDARD: 'feature:data_download:standard',
  SEGMENT_BILLING: 'feature:segment_billing:all',
  USAGE_EARLY_STAGE: 'plan:usage_early_stage',
  USAGE_MEDIUM_BUSINESS: 'plan:usage_medium_business',
  USAGE_SMALL_BUSINESS: 'plan:usage_small_business',
} as const)
